import { render } from "./tickets-overdue.vue?vue&type=template&id=57ad1f4b"
import script from "./tickets-overdue.vue?vue&type=script&lang=js"
export * from "./tickets-overdue.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__